var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38748 12.8614C10.3311 12.8614 12.7173 10.4751 12.7173 7.53152C12.7173 4.58792 10.3311 2.20166 7.38748 2.20166C4.44388 2.20166 2.05762 4.58792 2.05762 7.53152C2.05762 10.4751 4.44388 12.8614 7.38748 12.8614Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0499 14.1939L11.1851 11.3291",
    stroke: "#9CA3AF",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a1aec82123fd106570aa7b75949d1c45.svg";
export { ForwardRef as ReactComponent };